module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>star</title><path d=\"M25,2.73l7.14,14.5.12.24.26,0,16,2.34L36.93,31.13l-.19.18,0,.26,2.78,15.91L25.23,40,25,39.84l-.23.12L10.43,47.49l2.78-15.91,0-.26-.19-.18L1.46,19.85l16-2.34.26,0,.12-.24L25,2.73M25,1.6,17.41,17,.38,19.5l12.34,12-3,16.91,15.23-8,15.23,8-3-16.91,12.34-12L32.59,17,25,1.6Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star-01.svg
// module id = 1039
// module chunks = 1